export default {
    postEditor: { method: 'post', url: 'api/secure/technical_report_editor'},
    getAllEditors: { method: 'get', url: 'api/secure/technical_report_editor'},
    putEditor: { method: 'put', url: 'api/secure/technical_report_editor/{id}' },
    deleteEditor: { method: 'delete', url: 'api/secure/technical_report_editor/{id}'},
}